<template>
  <div class="login-wrap" :style="{background: 'url('+bgimg+')',backgroundSize: '100% 100%'}">
    	<div class="l-title">
        <img :src='loginUrl' class="logo"/>
    		<h3>HM2000综合能源管理云平台</h3>
    		<p>用能数据实时监控、能耗分析、优质用电、 在线支付</p>
    	</div>

    <div class="login-container">
       <div class="codeBox">
         <img :src="codeUrl" />
         <div class="js">
           <p>微信扫一扫</p>
           <p>使用小程序</p>
         </div>
       </div>
       <div class="login-content">
         <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm login-box ">

           <h2 class="title">用户登录</h2>

           <el-form-item prop="username" style="margin-bottom: 26px;" >
             <el-input prefix-icon="el-icon-user-solid" type="text" v-model="ruleForm.username" auto-complete="off" placeholder="账号"></el-input>
           </el-form-item>
           <el-form-item prop="password" style="margin-bottom: 26px;">
             <el-input  type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码">
               <i slot="prefix" class="el-input__icon fa fa-lock"></i>
             </el-input>
           </el-form-item>
           <el-row :gutter="16" style="margin-bottom: 26px;">
             <el-col :span="12">
               <el-form-item prop="vcode">
                 <el-input type="text" v-model="ruleForm.vcode" auto-complete="off" placeholder="图形验证码" @keyup.enter.native="submitForm('ruleForm')"></el-input>
               </el-form-item>
             </el-col>
             <el-col :span="12" class="code-box" >
         			<div  @click="refreshCode">
         				<s-identify :fresh="flag" @makedCode="getMakedCode"></s-identify>
         			</div>
             </el-col>
           </el-row>
           <!-- <el-checkbox class="remember" v-model="rememberpwd">记住当前用户名</el-checkbox> -->
           <el-form-item style="width:100%;">
             <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
           </el-form-item>
         </el-form>
       </div>

    </div>


    <div class="copyright">
     <!-- <p>Copyright © (c) 2018-2020 广州昊美电力科技有限公司 版权所有</p> -->
    </div>
  </div>
</template>
<script >
import { login } from '../api/userMG'
import { sendMeterInfoMsg} from '../api/payMG.js'
import { setCookie, getCookie, delCookie } from '../utils/util'
import SIdentify from '@/components/identify.vue'
import md5 from 'js-md5'
import store from '@/vuex/store'
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
			bgimg:require("../assets/img/bg.jpg"),
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
				vcode:'',
        // randomStr: '',
        // codeimg: ''
      },
      //rules前端验证
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        vcode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
			flag:true,  //该值变化，就会触发刷新
      code:'',
      codeUrl:require("../assets/img/code.png"),
      loginUrl:require("../assets/img/logo.png")

    }
  },



	components: {
		SIdentify
	},
  // 创建完毕状态(里面是操作)
  created() {

    this.getuserpwd()


  },
	mounted(){
		this.flag = !this.flag;

		if(store.state.isRe){
			this.$message.info('登录过期！ 重新登录')
		}
	},
  // 里面的函数只有调用才会执行
  methods: {

		refreshCode() {

      this.flag = !this.flag;
    },
    getMakedCode(code){
      this.code = code
   
    },


    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')

        this.rememberpwd = true
      }
    },
    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true

					if(this.ruleForm.vcode != this.code){
						this.$message.error("验证码错误！请重新输入")
						this.refreshCode()
						 this.logining = false
						return
					}

					let p = {
						 username: this.ruleForm.username,
						 password: this.ruleForm.password,
					}
          login(p).then(res => {
						if( res.errCode){
							 this.logining = false
							 this.$message.error(res.msg)
							 return
						}
            if (res.data.status == 1) {
              // this.$store.dispatch('getSendMsg')
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.logining = false

                console.log(res)

                // 缓存用户个人信息
                sessionStorage.setItem('userdata', JSON.stringify(res.data.data))
                sessionStorage.setItem('token', res.data.data.token)
              

                this.$store.commit('login', true)
                 if(res.data.data.accountType == 1 || res.data.data.accountType == 2){
                  if(res.data.data.username == 'admin'){
                    this.$router.push({ path: '/charts/summary' })
                  }else{
                    this.$router.push({ path: '/charts/statistics' })
                  }
                }else{
                  this.$router.push({ path: '/charts/noPrepayment' })
                }
              }, 1000)
            } else {
              this.$message.error(res.data.msg)
              this.logining = false
              return false
            }
          })

        } else {
          // 获取图形验证码
          this.refreshCode()

          this.logining = false
          return false
        }
      })
    },
  }
}
</script>

<style scoped>
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 10%;
  position: relative;
}
.login-container {
  width: 440px;
  height: 440px;
  overflow: hidden;
  margin: 2% auto 0 auto;
  display: flex;
}
.codeBox{
  height: 440px;
  width: 440px;
  background: rgba(0,0,0,0.5);
  border-radius:8px 0px 0px 8px;
  text-align: center;
  display: none;
}
.login-content{
  border-radius:8px;
  height: 440px;
  width: 440px;
   background: rgba(255,255,255,1);
   border: 1px solid #eaeaea;
   text-align: left;
   box-shadow:0px 1px 3px 1px rgba(40,116,181,1);
  	position: relative;
}
.codeBox img{
  width: 188px;
  height: 211px;

  margin-top: 90px;
  margin-left: 80px;
  float: left;
}
.codeBox .js{
  width: 150px;
  color: #fff;
  font-size: 24px;
  margin-top: 150px;
  float: left;
  line-height: 14px;


}

.login-box{
  margin: 30px 50px;
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;

}
.remember {
  margin: 0px 0px 35px 0px;
}
.code {

    width: 114px;
    height: 40px;

 }
 .copyright{
	 width: 100%;
	 color: #fff;
	 text-align: center;
	 position: fixed;
	 bottom: 20px;
	 left: 0;
 }
 .copyright img{
   position: absolute;
   bottom: 50px;
   left: 50%;
   margin-left: -75px;
 }
 .l-title{
  position: absolute;
	color: #fff;
  top: 40px;
  left: 60px;
 }
 .logo{
   position: absolute;
   width: 100px;
   top: 10px;
 }
 .l-title h3{
   padding-left:110px;
	 font-size: 30px;
   margin: 0;

 }
  .l-title p{
		font-size: 20px;
    padding-left:110px;
    margin: 0;
    line-height: 46px;
	}

  @media screen and (max-width: 1400px) {
    .login-container {
      width: 800px;
      height: 400px;
      overflow: hidden;
      margin: 2% auto 0 auto;
      display: flex;
    }
    .codeBox{
      height: 400px;
      width: 400px;

    }
    .login-content{
      border-radius:0px 8px 8px 0px;
      height: 400px;
      width: 400px;

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue